import React, { useEffect, useRef, useState } from "react";
import search from "../Images/search.png";
import backBtn from "../Images/back.png";
import profile from "../Images/profile.png";
import add from "../Images/add.png";
import "../css/consultations.css";
import "../css/doctors.css";
import triangle from "../Images/triangle.png";
import copy from "../Images/copy_green.png";
import "../css/patients.css";
import heart from "../Images/heart.png";
import { Link } from "react-router-dom";
import { Search, User } from "lucide-react";

function Patients() {
  const searchInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [healthGoal, setHealthGoal] = useState(null);
  const [selectedDoctors, setSelectedDoctors] = useState({});

  const fetchPatients = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/patients-user/`
      );
      const json = await response.json();
      if (response.ok) {
        setPatients((prev) => [
          ...(json.patients_with_doctor || []),
          ...(json.patients_without_doctor || []),
        ]);
      }
    } catch (error) {
      console.error('Error fetching patients:', error);
    }
  };

  const handleDoctorChange = async (patientId, doctorId) => {
    try {
      console.log('Making request with:', {
        patientId,
        doctorId,
        url: `${process.env.REACT_APP_BASE_URL}/api/asian-doctor/${patientId}/`
      });
  
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/asian-doctor/${patientId}/`, 
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            doctor_id: parseInt(doctorId)
          })
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Error response:', errorData);
        throw new Error(errorData.message || 'Failed to update doctor');
      }
  
      const data = await response.json();
      console.log('Success response:', data);
      
      // Refresh the patients list
      await fetchPatients();
  
    } catch (error) {
      console.error('Error updating doctor:', error);
      alert('Failed to update doctor. Please try again.');
    }
  };

  const handleSearchClick = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setIsFocused(true);
    }
  };

  const getImageUrl = (imageField) => {
    if (!imageField) return profile;
    
    // If the image path starts with 'user_images/', prepend the base URL
    if (imageField.startsWith('user_images/')) {
      return `${process.env.REACT_APP_BASE_URL}/media/${imageField}`;
    }
    
    // If it's already a full URL, use it as is
    if (imageField.startsWith('http')) {
      return imageField;
    }
    
    // Otherwise, construct the full URL
    return `${process.env.REACT_APP_BASE_URL}${imageField}`;
  };

  const handleBlur = (e) => {
    if (e.relatedTarget && e.relatedTarget.closest(".allResults")) {
      return; // Prevent losing focus if clicking inside allResults
    }
    setIsFocused(false);
  };

  const [allDoctors, setAllDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [doctor, setDoctor] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/doctor-user/`
        );
        const json = await response.json();
        if (response.ok) {
          setAllDoctors(json);
        }
      } catch (error) {
        console.error('Error fetching doctors:', error);
      }
    };


    const fetchData2 = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/patients-user/`
        );
        const json = await response.json();
        if (response.ok) {
          setPatients((prev) => [
            ...(json.patients_with_doctor || []),
            ...(json.patients_without_doctor || []),
          ]);
          console.log('Fetched patients:', json); // Debug log
        }
      } catch (error) {
        console.error('Error fetching patients:', error);
      }
    };

    fetchDoctors();
    fetchData2();
    fetchPatients();
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filteredPatients = patients.filter(
        (patient) =>
          patient?.full_name?.toLowerCase().includes(lowercasedSearchTerm) ||
          patient.id.toString().includes(lowercasedSearchTerm),
      );
      const filteredDoctors = allDoctors.filter((doctor) =>
        doctor?.username?.toLowerCase().includes(lowercasedSearchTerm),
      );
      setFilteredResults([...filteredPatients, ...filteredDoctors]);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, patients, allDoctors]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    // console.log("speciality", speciality, "doctor", doctor);
  }, [speciality, doctor]);

  const [ccIndex, setCcIndex] = useState(0);
  const [medIndex, setMedIndex] = useState(0);

  const handleCcLeftSlide = () => {
    if (ccIndex > 0) {
      setCcIndex(ccIndex - 1);
      // console.log(ccIndex);
    }
  };

  const handleCcRightSlide = () => {
    if (ccIndex < 2) {
      setCcIndex(ccIndex + 1);
      // console.log(ccIndex);
    }
  };

  const handleMedLeftSlide = () => {
    if (medIndex > 0) {
      setMedIndex(medIndex - 1);
      // console.log(medIndex);
    }
  };
  const handleMedRightSlide = () => {
    if (medIndex < 2) {
      setMedIndex(medIndex + 1);
      // console.log(medIndex);
    }
  };
  return (
    <div className="conMain docMain">
      {isFocused && <div className="blur"></div>}
      <div className="sna">
        <div className="searchnRes">
          <div className="cdpNavbar" onClick={handleSearchClick}>
            <div className="cdpn">
              <div className="cdpSearch">
                <input
                  type="text"
                  placeholder="Search Patients & Doctors"
                  ref={searchInputRef}
                  onBlur={handleBlur}
                  onFocus={() => setIsFocused(true)}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <div className="">
                  <Search className="w-5 h-5 m-2 text-pink-500" />
                </div>
              </div>
            </div>
            <img src={profile} alt="profile" />
          </div>

          {isFocused && searchTerm && (
            <div
              className="allResults"
              tabIndex={-1}
              onMouseDown={(e) => e.preventDefault()}
            >
              <p>Search Results</p>
              {filteredResults.length > 0 ? (
                filteredResults.map((result, index) => (
                  <span
                    onClick={() => { result.role === "PATIENT" ? window.location.href = `/dash2/${result.id}` : window.location.href = `/doctor/${result.id}` }}
                    key={index}
                    className="resultItem"
                  >
                    <p>{result.full_name || result.username}</p>
                  </span>
                ))
              ) : (
                <p>No results found</p>
              )}
            </div>
          )}
        </div>
        <div className="cdpNewOn allCon">
          {patients.map((pt, index) => (
            <div className="cdpno" key={index}>
              <div className="cdpProf">
                <div className="pinkBox">
                  <div className="profImg">
                  <img 
                    src={getImageUrl(pt.image)}
                    alt={`${pt.full_name}'s profile`}
                    className="w-12 h-12 rounded-full object-cover" />  
                   <div className="pDesc">
                      {console.log("pt", pt)}
                      <p>{pt.full_name}</p>
                      <p>{pt.phone_number}</p>
                      <p>PID: {pt.id}</p>
                    </div>
                  </div>
                  <Link to={{ pathname: `/dash2/${pt.id}`, state: { pt } }}>
                    <button>View Dashboard</button>
                  </Link>
                </div>
                <div className="hfu">
                  <Link to={`/dash2/${pt.id}/helpan`}>
                    <button>
                      <img src={heart} alt="heart" />
                      <p>Health Plan</p>
                    </button>
                  </Link>
                  <Link to={`/dash2/${pt.id}/folup`}>
                    <button>
                      <img src={heart} alt="heart" />
                      <p>Follow Up</p>
                    </button>
                  </Link>
                </div>
                <div className="pinkBox">
                  <p>Focus Area</p>
                  <HealthGoal2 patientId={pt.id} />
                </div>

                <div className="pinkBox pb">
                <p>Linked Doctor</p>
                <select 
  className="w-full p-2 mt-1 rounded border border-pink-200 focus:outline-none focus:border-pink-500"
  value={pt.doctor?.id || ''}
  onChange={(e) => handleDoctorChange(pt.id, e.target.value)}
>
  <option value="">Select Doctor</option>
  {allDoctors.map((doctor) => (
    <option key={doctor.id} value={doctor.id}>
      {doctor.username}
    </option>
  ))}
</select>
              </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Patients;

const HealthGoal2 = (props) => {
  const [healthGoal2, setHealthGoal2] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/health-goal/${props.patientId}/`,
        );
        const json = await response.json();
        if (response.ok) {
          setHealthGoal2(json.helth_goal.name);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return <b> {healthGoal2 ? healthGoal2 : "NA"} </b>;
};
